import { ReactNode, createContext, useContext } from 'react';
import { HubSpotDealUpdateRequest } from 'vopay';
import usePostHubSpotDealUpdate from '../hooks/useApi/usePostHubSpotDealUpdate';
import type { HubSpotDealUpdateResponse } from '../hooks/useApi/usePostHubSpotDealUpdate';

type HubSpotDataCtx = {
  response: HubSpotDealUpdateResponse | undefined;
  postHubSpotData: (requestParams: HubSpotDealUpdateRequest) => void;
  reset: () => void;
};

const defaultData = { success: false, errorMessage: '' };

export const HubSpotDataContext = createContext<HubSpotDataCtx>({
  response: defaultData,
  postHubSpotData: () => {},
  reset: () => {},
});

export const HubSpotDataProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [response, postHubSpotData, reset] = usePostHubSpotDealUpdate({});

  return (
    <HubSpotDataContext.Provider
      value={{
        response,
        postHubSpotData,
        reset,
      }}
    >
      {children}
    </HubSpotDataContext.Provider>
  );
};

export const useHubSpotData = (): HubSpotDataCtx => useContext(HubSpotDataContext);
